import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: 'Roboto', sans-serif;
    /* font-weight: normal; */ // Comentado para avaliar se é realmente importante, esse ajuste impossibilita o uso de Trans Component do i18next para interpolar partes do texto de tradução.
  }

  body {
    background: #f7f7f7;
  }
  .Toastify__progress-bar--success {
    background: #d33000 !important;
  }

  .Toastify__progress-bar--error {
    background: #f1bc00 !important;
  }

`;

export default GlobalStyle;
